export default "__VITE_ASSET__f52e3194__"